module.exports = __webpack_public_path__ + "img/svi_sm.9b8bb4e4.png";